import styled from 'styled-components';

type SideNavSectionProps = {
  title: string;
  visible?: boolean;
} & React.PropsWithChildren;

export function SideNavSection({ title, children, visible = true }: SideNavSectionProps) {
  if (!visible) return null;
  return (
    <StyledSection>
      <Title>{title}</Title>
      {children}
    </StyledSection>
  );
}

const StyledSection = styled.div`
  margin-top: 24px;
`;

const Title = styled.span`
  display: block;
  font-weight: 400;
  font-size: 10px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 1.5%;
  color: ${({ theme }) => theme.colors.white50};
  margin: 0 0 7px 16px;
  text-transform: uppercase;
`;
